const { isEmpty } = _uo.utility;

/**
 * Finds a loop in the recipe using the loop ID
 *
 * @param {Number} loopID The look ID
 * @return {Object} The loop
 */
const getLoop = ( loopID ) => {
	if ( isEmpty( loopID ) ) {
		throw new Error( `getLoop: loopID must be defined` );
	}

	return UncannyAutomator._recipe.actions.items.find( item => item.id === loopID );
}

export default getLoop;
